import WithGASetup from '../WithGASetup';
import UserExists from './UserExists';

export default WithGASetup(UserExists);
